import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=56ba9ff6&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=56ba9ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba9ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ba9ff6')) {
      api.createRecord('56ba9ff6', component.options)
    } else {
      api.reload('56ba9ff6', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=56ba9ff6&scoped=true&", function () {
      api.rerender('56ba9ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/main/Navigation.vue"
export default component.exports